import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    selector: 'loader',
    template: '',
    styleUrls: ['./loader.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class LoaderComponent {}
